angular.module('impactx.cscontract').controller('CSContractInterfaceDataCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'ToolbarService',
    'PartialDialogsService',
    'TranslationService',
    CSContractInterfaceDataCtrl
]);

function CSContractInterfaceDataCtrl($scope, dataGen, $routeParams, ToastService, BackService, ToolbarService, PartialDialogsService, TranslationService) {
    var self = this;
    
    self.save = function ($event) {
        return dataGen.postAsForm($scope, {interfaceData: $scope.data}, "/cscontract/interface/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.id, 'cscinterface', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.id}, "/cscontract/interface/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}